import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Compatibilidad con LoginForm si todavía importa desde rutaUsuarios
export { postLogin } from "./rutaLogin";

const authConfig = (extra = {}) => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt") ||
    "";

  return {
    ...extra,
    headers: {
      ...(extra.headers || {}),
      token,
      Authorization: token
        ? `Bearer ${token}`
        : undefined,
    },
  };
};

const respuestaError = (error) => ({
  ok: false,
  err: {
    message:
      error.response?.data?.err?.message ||
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "No se pudo conectar con el servidor",
  },
});

export const getUsuarios = async (params = {}) => {
  try {
    const resp = await api.get(
      "/usuarios",
      authConfig({ params })
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const getUsuariosColaboradores = async () => {
  try {
    const resp = await api.get(
      "/usuarios/colaboradores",
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const getResumenUsuarios = async () => {
  try {
    const resp = await api.get(
      "/usuarios/resumen",
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const postUsuario = async (datos) => {
  try {
    const resp = await api.post(
      "/usuarios",
      datos,
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const putUsuario = async (id, datos) => {
  try {
    const resp = await api.put(
      `/usuarios/${id}`,
      datos,
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const desactivarUsuario = async (id) => {
  try {
    const resp = await api.delete(
      `/usuarios/${id}`,
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const activarUsuario = async (id) => {
  try {
    const resp = await api.patch(
      `/usuarios/${id}/activar`,
      {},
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const resetPasswordUsuario = async (id) => {
  try {
    const resp = await api.post(
      `/usuarios/${id}/reset-password`,
      {},
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const resetPasswordsMasivo = async (sede = "") => {
  try {
    const resp = await api.post(
      "/usuarios/reset-passwords-masivo",
      {
        sede: sede || undefined,
      },
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const importarUsuariosMasivo = async (usuarios = []) => {
  try {
    const resp = await api.post(
      "/usuarios/importar-masivo",
      {
        usuarios,
      },
      authConfig()
    );

    return resp.data;
  } catch (error) {
    // Conserva también el detalle de usuarios rechazados
    // que devuelve el backend.
    if (error.response?.data) {
      return error.response.data;
    }

    return respuestaError(error);
  }
};

export const cambiarMiPassword = async (
  passwordActual,
  passwordNueva
) => {
  try {
    const resp = await api.put(
      "/usuarios/mi-password",
      {
        passwordActual,
        passwordNueva,
      },
      authConfig()
    );

    return resp.data;
  } catch (error) {
    return respuestaError(error);
  }
};

export const descargarUsuariosCsv = async (params = {}) => {
  try {
    const resp = await api.get(
      "/usuarios/exportar.csv",
      authConfig({
        params,
        responseType: "blob",
      })
    );

    const disposition =
      resp.headers["content-disposition"] || "";

    const coincidencia = disposition.match(
      /filename="?([^";]+)"?/i
    );

    const nombre =
      coincidencia?.[1] || "usuarios.csv";

    const url = window.URL.createObjectURL(
      new Blob([resp.data])
    );

    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", nombre);

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    return { ok: true };
  } catch (error) {
    return respuestaError(error);
  }
};